import breakpointChecker from "../utils/breakpointChecker"
export default () => {
  (function($) {
    $(document).ready(function() {
      $('.header__subnav').hide()
      $('.nav__item').hover(function() {
        $('.header__main').addClass('fillup')
        $('.nav__nav.current').removeClass('current')
        $(this).find('.nav__nav').addClass('current')
        $('.header__subnav').hide()
        var _submenu = $(this).find('.header__subnav').attr('aria-hidden', 'false')
        if (_submenu.length > 0) {
          _submenu.show()
          return false
        }
      }, function() {
        $('.header__subnav').hide().attr('aria-hidden', 'true')
        $('.header__main').removeClass('fillup')
        $('.nav__nav.current').removeClass('current')
      })

      // accessibility 
      $('.nav__nav a').on('touchstart focus', function() {
        var _submenu = $(this).parents('.nav__nav').siblings('.header__subnav')
        $('.nav__nav a').removeClass('active')
        $('.header__main').attr('style', '')
        if (_submenu.length > 0) {
          if (_submenu.is(':visible')) {
            $('.header__subnav').hide().attr('aria-hidden', 'true')
          } else {
            $('.header__main').css({
              background: '#fffdf9'
            })
            $('.header__subnav').hide().attr('aria-hidden', 'true')
            _submenu.show().attr('aria-hidden', 'false')
            $(this).addClass('active')
          }
          return false
        }
      })

      $('.header__subnav .submenu__item:last-child a').on('blur', function() {
        $('.nav__nav a').removeClass('active')
        $('.header__main').attr('style', '')
        $('.header__subnav').hide().attr('aria-hidden', 'true')
      })
    })

    $(document).ready(function() {
      $('.navPanel').hide()
      $('.mobileNav__item--hamburger button').on('click', function() {
        $(this).toggleClass('is-active')
        if ($(this).is('.is-active')) {
          $('.mobileNav__item--search').hide()
          $('.header__panel').addClass('is-active')
          $('.navPanel').show()
          $('.navPanel__link a, .navPanel__end a').attr('aria-hidden', 'false')
          $('.header:not(.header--entry)').css('bottom', 0)
          $('body').css('overflow', 'hidden').addClass('enabledFullPanel')
          $('.header__main').css({
            background: '#fffdf9'
          })
          $('.header__main').addClass('header__main--noGradiant')
        } else {
          $('.mobileNav__item--search').show()
          $('.header__panel').removeClass('is-active')
          $('.navPanel, .mobileNav__item--search').hide()
          $('.navPanel__link a, .navPanel__end a').attr('aria-hidden', 'true')
          $('.search--mobile').hide()
          $('.mobileNav__item--search').removeClass('opened')
          $('body').removeClass('enabledFullPanel')
          $('body, .header').attr('style', '')
          $('.header__main').attr('style', '')
          $('.mobileNav__item--search').attr('style', '')
          headerStyle()
        }
        if ($('.mobileNav__item--search').is('.opened')) {
          $('.search--toggle').trigger('click')
        }
      })
      const headerStyle = function() {
        if ($(window).scrollTop() > 90) {
          $('.header__main').addClass('header__main--noGradiant')
        } else {
          $('.header__main').removeClass('header__main--noGradiant')
        }
      }
      const BPChecker = new breakpointChecker({
        mediaQuery: '(min-width:992px)',
        onMatch: function() {
          $('body').removeClass('enabledFullPanel')
          $('body, .header').attr('style', '')
          $('.header__main').attr('style', '')
          $('.header__main').removeClass('header__main--noGradiant')
          $(window).off('scroll', headerStyle)
          if ($('.mobileNav__item--hamburger button').is('.is-active')) {
            $('.mobileNav__item--hamburger button').trigger('click')
          }
          $('.navPanel__subItem a, .navPanel__end a').attr('aria-hidden', 'true')
        },
        onDifferent: function() {
          $(window).on('scroll', headerStyle)
          $('.navPanel__subItem a, .navPanel__end a').attr('aria-hidden', 'false')
        }
      })
    })

    $(document).ready(function() {
      $('.navPanel__subList').hide()
      $('.navPanel__item button.navPanel__expandIcon').on('click', function() {
        if ($(this).is('.active') && $(this).parents('.navPanel__link').siblings('.navPanel__subList').length >= 0) {
          $('.navPanel__subList').hide().find('a').attr('aria-hidden', 'true')
          $('.navPanel__item button.navPanel__expandIcon').removeClass('active')
          if($(this).hasClass('active')){
            $(this).prev('a').addClass('active')
          } else {
            $(this).prev('a').removeClass('active')
          }
          $(this).attr('aria-expanded', false)
          return
        } else {
          $('.navPanel__subList').hide()
          $('.navPanel__item button.navPanel__expandIcon').removeClass('active')
          $(this).parents('.navPanel__link').siblings('.navPanel__subList').show().find('a').attr('aria-hidden', 'false')
          $(this).addClass('active')
          if($(this).hasClass('active')){
            $(this).prev('a').addClass('active')
          } else {
            $(this).prev('a').removeClass('active')
          }
          $(this).attr('aria-expanded', true)
        }
      })
      $('.navPanel__subItem a').on('click', function() {
        $('button.hamburger').trigger('click')
      })

    })
  })(window.hsvmJQuery)
}